import { render, staticRenderFns } from "./ModalMessageParts.vue?vue&type=template&id=78f5db3a&scoped=true"
import script from "./ModalMessageParts.vue?vue&type=script&lang=ts"
export * from "./ModalMessageParts.vue?vue&type=script&lang=ts"
import style0 from "./ModalMessageParts.vue?vue&type=style&index=0&id=78f5db3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5db3a",
  null
  
)

export default component.exports